import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/atoms/popover';
import { cn } from '@/lib/utils';
import { NANP_COUNTRIES, nanpCountryMeta, type NanpCountry } from './address-draft';

/** US/CA country select (NANP) — same Popover look as the phone country selector. */
export function AddressCountrySelect({
  value,
  onChange,
}: {
  value: NanpCountry;
  onChange: (code: NanpCountry) => void;
}) {
  const [open, setOpen] = useState(false);
  const active = nanpCountryMeta(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex h-9 w-full max-w-[14rem] items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-xs hover:bg-muted/40 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 dark:bg-input/30"
        >
          <span className="flex items-center gap-2">
            <span className="text-base leading-none">{active.flag}</span>
            {active.label}
          </span>
          <ChevronDown className="size-4 shrink-0 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-1" align="start">
        {NANP_COUNTRIES.map((entry) => (
          <button
            key={entry.code}
            type="button"
            onClick={() => {
              onChange(entry.code);
              setOpen(false);
            }}
            className={cn(
              'flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-muted',
              entry.code === value && 'bg-muted',
            )}
          >
            <span className="text-base leading-none">{entry.flag}</span>
            {entry.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
